import React from 'react';

const SvgFacebook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.7857 0H2.21429C1.75963 0 1.32359 0.180612 1.0021 0.502103C0.680612 0.823594 0.5 1.25963 0.5 1.71429L0.5 14.2857C0.5 14.7404 0.680612 15.1764 1.0021 15.4979C1.32359 15.8194 1.75963 16 2.21429 16H7.11607V10.5604H4.86607V8H7.11607V6.04857C7.11607 3.82893 8.4375 2.60286 10.4614 2.60286C11.4307 2.60286 12.4443 2.77571 12.4443 2.77571V4.95429H11.3275C10.2271 4.95429 9.88393 5.63714 9.88393 6.3375V8H12.3404L11.9475 10.5604H9.88393V16H14.7857C15.2404 16 15.6764 15.8194 15.9979 15.4979C16.3194 15.1764 16.5 14.7404 16.5 14.2857V1.71429C16.5 1.25963 16.3194 0.823594 15.9979 0.502103C15.6764 0.180612 15.2404 0 14.7857 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgFacebook;
